












import { defineComponent, ref } from "@vue/composition-api";
import { debounce } from "lodash";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import providers from "@/lib/api";
import SearchUserView from "./components/SearchUserView.vue";
import { FollowerMappedType } from "./type";

export default defineComponent({
  name: "PageSearchUser",
  components: { SearchUserView },
  setup() {
    const screenNameValue = ref<string>("");
    const loading = ref<boolean>(false);
    const users = ref<UserPublicData[]>([]);
    const followingInProcessUsers = ref<string[]>([]);
    const mappedFollowings = ref<FollowerMappedType>({});
    const searchFollowings = async () => {
      const mappedFollowingUsers: FollowerMappedType = {};
      const followers = await providers.FollowingsProvider.searchFollowings({
        ids: users.value.map(user => user.id),
      });
      followers.forEach(i => (mappedFollowingUsers[i.userId] = i));
      mappedFollowings.value = { ...mappedFollowingUsers };
    };

    const search = debounce(async (value: string) => {
      loading.value = true;
      if (value.length > 0) {
        try {
          users.value = await providers.UserPublicDataProvider.relevantSearchByName({
            name: value,
            filterRole: "creator",
          });
          if (users.value.length) {
            await searchFollowings();
          }
        } finally {
          loading.value = false;
        }
      } else {
        loading.value = false;
        users.value = [];
        mappedFollowings.value = {};
      }
    }, 500);

    const onInputHandler = (value: string) => {
      screenNameValue.value = value;
      search(value);
    };

    const follow = async (user: UserPublicData) => {
      try {
        followingInProcessUsers.value = [...followingInProcessUsers.value, user.id];
        await providers.FollowingsProvider.toggle({ id: user.id });
        await searchFollowings();
      } finally {
        followingInProcessUsers.value = [...followingInProcessUsers.value.filter(id => id !== user.id)];
      }
    };

    return {
      screenNameValue,
      loading,
      onInputHandler,
      users,
      mappedFollowings,
      follow,
      followingInProcessUsers,
    };
  },
});
